import React from "react";
import { ErrorMessage, useField } from "formik";

const Checkbox = ({ children, ...props }) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });
  return (
    <div className="checkbox-group">
      <input className="form-check-input" id="checkbox" {...field} {...props} type="checkbox" />
      {children}
      <b className="checkbox">
        {meta.touched && meta.error && (
          <span id="error">
            <ErrorMessage name={props.name} />
          </span>
        )}
      </b>
    </div>
  );
};
export default Checkbox;
